import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalProvider } from './context/GlobalContext';
import Home from './pages/Home';
import Documentation from './pages/Documentation';
import './App.css';

function App() {
  return (
    <GlobalProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/documentation" element={<Documentation />} />
          </Routes>
        </div>
      </Router>
    </GlobalProvider>
  );
}

export default App;
